/**
 * Optimizer Control Center — pull the portable recipe out of a full config
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FlowOptimizerConfig } from '@trafficpulse/shared';

import {
  stripFormulaIgnores,
  stripTreeIgnores,
} from '@/features/flow-optimizer/ignore-paths/strip-ignored-paths';

import type { PortableOptimizerConfig } from './optimizer-clipboard.types';

/**
 * Keep only the provider-agnostic recipe fields. Target identity, the
 * flow-specific `standardJson`, run-state (enabled/killSwitch) and history are
 * intentionally dropped so a paste never overwrites a target's wiring or run
 * state — only its optimisation recipe.
 *
 * Per-path ignore lists are dropped for the same reason: they name bank rows of
 * THIS campaign's flow and mean nothing anywhere else.
 */
export function extractPortableConfig(
  config: FlowOptimizerConfig,
): PortableOptimizerConfig {
  return {
    mode: config.mode,
    intervalMin: config.intervalMin,
    minWeight: config.minWeight,
    maxWeight: config.maxWeight,
    excludeRules: stripTreeIgnores(config.excludeRules),
    capacityRules: config.capacityRules ?? [],
    formula: stripFormulaIgnores(config.formula),
    packageId: config.packageId ?? null,
  };
}
